"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SendParentInviteInvalidRequest extends client_library_1.ExtendableError {
    constructor() {
        super('Invalid request parameters when sending parent invite');
    }
}
exports.default = SendParentInviteInvalidRequest;
//# sourceMappingURL=SendParentInviteInvalidRequest.js.map